// extracted by mini-css-extract-plugin
module.exports = {"root":"CardShimmer_root__AOVJM","wrapper":"CardShimmer_wrapper___oMLu","first":"CardShimmer_first__3W72o","f2":"CardShimmer_f2__2iMl_","second":"CardShimmer_second__3bUEp"};